import OnEnterMixin from '@/components/mixins/onenter-mixin'

export default {
  name: 'popIdentifier',
  inject: [
    '$utils'
  ],
  components: {
  },
  props: {
    popIdsProp: {
      type: Array,
      default () { return [] }
    },
    popValueProp: {
      default () { return null }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    popValueProp (newVal) {
      this.popValue = newVal
      this.setDefaultValues()
    },
    currentTextValue (newVal) {
      this.setTextDisplay()
    },
    popIdsProp: {
      handler (newVal) {
        this.setDefaultValues()
      },
      deep: true
    }
  },
  mixins: [OnEnterMixin],
  data () {
    return {
      popValue: this.popValueProp,
      currentTextValue: '',
      currentTextDisplay: '',
      popIdInputValue: '',
      showPopIdElement: false,
      editText: false,
      showAddButton: true,
      popIds: [],
      inputValue: '',
      inputTagValueBeforeChanged: '',
      selectedTagItem: {
        index: null,
        origVal: null,
        newVal: null,
        createNewTag: false
      }
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('pop-identifier-change', { action, payload: { data } })
      }
    },
    setDefaultValues () {
      this.currentTextValue = this.popValue

      this.showPopIdElement = false
      this.editText = false
      this.showAddButton = true
      this.popIdInputValue = this.currentTextValue
      this.setTextDisplay()
      this.popIds = this.filterTagsItemForUI(this.popIdsProp)

      if (this.currentTextValue) {
        this.showPopIdElement = true
        this.showAddButton = false
      }
    },
    handleAddButtonClick () {
      this.showPopIdElement = true
      this.showAddButton = false
      this.editText = true

      this.$nextTick(_ => {
        this.$refs.addPopIdInputEl.focus()
      })
    },
    handleConfirmInputValue ($event, type) {
      const prevPoPIdentifierValue = this.currentTextValue
      this.currentTextValue = this.popIdInputValue ? this.popIdInputValue.trim() : ''
      this.editText = false

      if (!this.currentTextValue) {
        this.showAddButton = true
        this.showPopIdElement = false
      }

      this.emitEvent('POP_IDENTIFIER_UPDATED', {
        prevValue: prevPoPIdentifierValue,
        newValue: this.popIdInputValue
      })
    },
    handleBaseCoverClick ($event) {
      const isBaseCoverTargetEl = $($event.target).hasClass('base-cover')

      if (!isBaseCoverTargetEl) return

      this.editText = true
      this.showAddButton = false
      this.$nextTick(_ => {
        this.$refs.addPopIdInputEl.focus()
      })
    },
    handleDeletePopIdClick ($event) {
      this.popIdInputValue = ''
      this.handleConfirmInputValue()
    },
    setTextDisplay () {
      this.currentTextDisplay = this.currentTextValue
    },
    handlePopIdHover ($event, type) {
      const targetEl = $($($event.target).parent())
      const textEl = $($($event.target).parent()).find('.text')
      let showTooltip = textEl.length && (textEl[0].offsetWidth < textEl[0].scrollWidth)

      if (type === 'mouseover' && showTooltip) {
        showTooltip = true
      } else {
        showTooltip = false
      }

      this.$utils.handleCustomTooltip({ targetEl, showTooltip, fullText: textEl.text(), addTop: 8 })
    },
    querySearch (queryString, cb) {
      let links = this.$utils.clone(this.popIds)
      links = links.filter((t) => { return t.value !== this.currentTextDisplay })

      let results = queryString ? links.filter(this.createFilter(queryString)) : links

      results = this.$utils.sortTags({ tags: results }) // Sort popIds Alphabetically

      cb(results) // callback function to return suggestions
    },
    createFilter (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    filterTagsItemForUI (popIdsSrc) {
      let popIds = []

      popIdsSrc.forEach((tag) => {
        let newTag = tag

        if (typeof (newTag) === 'string') {
          newTag = { value: newTag }
        } else if (this.$utils.isObject(newTag) && newTag.name) {
          newTag.value = newTag.name
        }

        popIds.push(tag)
      })

      popIds = popIds.filter((t) => { return t.value !== '_toSeeAllData' })

      return this.$utils.filterTagOptionsForUI({ tags: popIds, showLabel: false })
    },
    handleInputTag ($event) {
    },
    onEnter (event) {
      if (event.target.id === 'popid-input') {
        this.handleConfirmInputValue(event, 'onEnter')
      }
    }
  },
  mounted () {
    this.setDefaultValues()
  }
}
